import { Operator } from "js-rules-engine";
import { ConditionOperators } from "./condition-operators.js";
import { valueContainsAny } from "./operators/any.js";
import { arrayEquals } from "./operators/array-equals.js";
import { valueIsBetween } from "./operators/between.js";
import { checked } from "./operators/checked.js";
import { valueContains } from "./operators/contains.js";
import { valueEqual } from "./operators/equal.js";
import { valueIsGreaterThan } from "./operators/greater-than.js";
import { valueIn } from "./operators/in.js";
import { valueIsDateNewerThan } from "./operators/is-date-newer-than.js";
import { valueIsDateOlderThan } from "./operators/is-date-older-than.js";
import { valueIsLessThan } from "./operators/less-than.js";
import { valueIsMissing } from "./utils.js";
function setUpOperators(defaultEngine, dateFactory) {
  const operators = [
    new Operator(ConditionOperators.empty, (value) => valueIsMissing(value)),
    new Operator(
      ConditionOperators.notEmpty,
      (value) => !valueIsMissing(value)
    ),
    new Operator(
      ConditionOperators.between,
      (givenValue, expectedValue) => valueIsBetween(givenValue, expectedValue)
    ),
    new Operator(
      ConditionOperators.greaterThan,
      (givenValue, expectedValue) => valueIsGreaterThan(givenValue, expectedValue)
    ),
    new Operator(
      ConditionOperators.after,
      (givenValue, expectedValue) => valueIsGreaterThan(givenValue, expectedValue)
    ),
    new Operator(
      ConditionOperators.greaterThanOrEqual,
      (givenValue, expectedValue) => valueIsGreaterThan(givenValue, expectedValue, true)
    ),
    new Operator(
      ConditionOperators.afterOrEqual,
      (givenValue, expectedValue) => valueIsGreaterThan(givenValue, expectedValue, true)
    ),
    new Operator(
      ConditionOperators.lessThan,
      (givenValue, expectedValue) => valueIsLessThan(givenValue, expectedValue)
    ),
    new Operator(
      ConditionOperators.before,
      (givenValue, expectedValue) => valueIsLessThan(givenValue, expectedValue)
    ),
    new Operator(
      ConditionOperators.lessThanOrEqual,
      (givenValue, expectedValue) => valueIsLessThan(givenValue, expectedValue, true)
    ),
    new Operator(
      ConditionOperators.beforeOrEqual,
      (givenValue, expectedValue) => valueIsLessThan(givenValue, expectedValue, true)
    ),
    new Operator(
      ConditionOperators.contains,
      (givenValue, expectedValue) => valueContains(givenValue, expectedValue)
    ),
    new Operator(
      ConditionOperators.equal,
      (givenValue, expectedValue) => valueEqual(givenValue, expectedValue)
    ),
    new Operator(
      ConditionOperators.notEqual,
      (givenValue, expectedValue) => !valueEqual(givenValue, expectedValue)
    ),
    new Operator(
      ConditionOperators.notContains,
      (givenValue, expectedValue) => !valueContains(givenValue, expectedValue)
    ),
    new Operator(
      ConditionOperators.arrayEqual,
      (givenValue, expectedValue) => arrayEquals(givenValue, expectedValue)
    ),
    new Operator(
      ConditionOperators.arrayNotEqual,
      (givenValue, expectedValue) => !arrayEquals(givenValue, expectedValue)
    ),
    new Operator(ConditionOperators.checked, checked),
    new Operator(
      ConditionOperators.notChecked,
      (givenValue) => !checked(givenValue)
    ),
    new Operator(
      ConditionOperators.any,
      (givenValue, expectedValue) => valueContainsAny(givenValue, expectedValue)
    ),
    new Operator(
      ConditionOperators.in,
      (givenValue, expectedValue) => valueIn(givenValue, expectedValue)
    ),
    new Operator(
      ConditionOperators.notIn,
      (givenValue, expectedValue) => !valueIn(givenValue, expectedValue)
    ),
    new Operator(
      ConditionOperators.isDateNewerThan,
      (givenValue, expectedValue) => valueIsDateNewerThan(givenValue, expectedValue, { dateFactory })
    ),
    new Operator(
      ConditionOperators.isDateOlderThan,
      (givenValue, expectedValue) => valueIsDateOlderThan(givenValue, expectedValue, { dateFactory })
    ),
    new Operator(
      ConditionOperators.isDateNewerThanOrEqual,
      (givenValue, expectedValue) => valueIsDateNewerThan(givenValue, expectedValue, {
        orEqual: true,
        dateFactory
      })
    ),
    new Operator(
      ConditionOperators.isDateOlderThanOrEqual,
      (givenValue, expectedValue) => valueIsDateOlderThan(givenValue, expectedValue, {
        orEqual: true,
        dateFactory
      })
    )
  ];
  operators.forEach((operator) => {
    defaultEngine.removeOperator(operator.name);
    defaultEngine.addOperator(operator);
  });
}
export {
  setUpOperators
};
//# sourceMappingURL=set-up-operators.js.map
